import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Djibouti: Country = {
    identifier: "Djibouti",
    name: "Djibouti",
    countryCode: "DJ",
    group: CountryGroup.AFRICA,
    isUNMember: true,
    flag: "🇩🇯",
    svgPath: "m 596.26475,430.6434 -0.243,0.381 -0.311,0.488 -0.353,0.554 -0.221,0.004 -0.171,-0.032 -0.118,-0.094 -0.242,-0.103 -0.273,-0.007 -0.26,0.096 -0.44,0.119 -0.398,0.039 -0.321,0.066 -0.265,0.077 -0.24,-0.042 -0.207,-0.069 -0.046,-0.59 -0.048,-0.64 0.005,-0.501 0.073,-0.276 0.065,-0.108 0.376,-0.381 0.13,-0.156 0.429,-0.632 0.369,-0.543 0.275,-0.405 0.085,-0.08 0.116,-0.078 0.082,0.023 0.536,0.391 0.094,-0.011 0.179,-0.121 0.162,-0.418 0.114,-0.153 0.049,0.004 0.344,-0.117 0.311,-0.133 0.04,0.138 0.47,0.562 0.155,0.276 0.157,0.506 -0.082,0.281 -0.123,0.184 -0.181,0.163 -0.629,0.401 -0.699,0.255 -0.446,0.511 -0.332,-0.035 0.051,0.193 0.123,0.022 0.194,-0.037 0.385,-0.148 0.341,-0.071 0.369,-0.005 0.334,0.064 z",
}
